import { gql } from '@apollo/client/core';

export const createStationLog = gql`
  mutation createStationLog($input: StationLogInput) {
    createStationLog(input: $input) {
      id
      date
      reasonId
      message
      fixSolution
      unitHours
      createdAt
      createdBy
      deletedAt
      updatedAt
      updater
      Reason {
        id
        reason
      }
    }
  }
`;
